module.exports = __webpack_public_path__ + "assets/img/4_1610_big.20c3cc6a.jpg";